import {
    DialogSize,
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSimpleInputOutlined,
    RaikoErrorSection,
    showSuccessMessage, showWarningMessage, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useEffect, useState} from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {CategoryService} from "../../serverService/categoryService/CategoryService";
import {useAuthState} from "../../context/AuthContext";
import {MagazineCategoryParser} from "../magazineCategory/MagazineCategoryParser";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Helmet} from "react-helmet";
import {RaikoFlexAlignEnd} from "@moeindal/base-raiko-panel-components";
import {RaikoTree} from "@moeindal/base-raiko-panel-components";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";

export default function CostAndRevenueCategory() {


    const {fundID} = useAuthState()

    const [name, setName] = useState("");
    const [parent, setParent] = useState(-1);
    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [categoryPersianList, setCategoryPersianList] = useState([]);
    const [selectedItemsId, setSelectedItemsId] = useState(-1);

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new CategoryService()

    useEffect(() => {
        getCategoryFromServer()
    }, []);


    function getCategoryFromServer() {
        loading.show()
        service.getCategoryList(fundID)
            .then(response => {
                const categoryParser = new MagazineCategoryParser(response)
                setCategoryPersianList(categoryParser.getCategoryListParsed())
                setCategoryInlineItems(categoryParser.getCategoryListInlineParser())
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleCreateNewCategory() {
        loading.show()
        service.createNewCategory(fundID, name, parent)
            .then(response => {
                showSuccessMessage("دسته بندی جدید با موفقیت افزوده شد.")
                getCategoryFromServer()
                clearAllFields()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function clearAllFields() {
        setName("")
        setParent(-1)
    }

    function handleCloseDialog() {
        setSelectedCategoryId(-1)
        setCategoryDetailDialogOpenState(false)
    }

    const [selectedName, setSelectedName] = useState("");
    const [selectedParentId, setSelectedParentId] = useState(-1);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
    const [categoryDetailDialogOpenState, setCategoryDetailDialogOpenState] = useState(false);

    function handleSelectCategoryItem(itemId, itemName, slug, itemParentId) {
        setSelectedCategoryId(itemId)
        setSelectedName(itemName)
        setSelectedParentId(itemParentId)
        setCategoryDetailDialogOpenState(true)
    }

    function checkAllFields(categoryName, categoryParentId) {
        let state = true;
        let message = ""

        if (categoryName.length === 0) {
            message = "لطفا نام دسته بندی بازی را وارد نمایید"
        } else if (categoryParentId === -2) {
            message = "لطفا دسته بندی پدر را مشخص نمایید"
        } else
            state = true
        if (message && message.length > 0) {
            showWarningMessage(message)
        }
        return state

    }

    function updateCategory() {
        if (checkAllFields(selectedName, selectedParentId)) {
            loading.show()
            service.updateCategoryInfo(
                fundID,
                selectedName,
                selectedParentId,
                selectedCategoryId
            ).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    getCategoryFromServer()
                    setCategoryDetailDialogOpenState(false)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.CostAndRevenueCategory.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={categoryDetailDialogOpenState}
                pageTitle={"جزئیات دسته بندی"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <RaikoGridOneColumn className={css`margin: 0 1rem 1rem 1rem`}>
                    <RaikoSimpleInputOutlined labelText={"نام"} setValue={setSelectedName} value={selectedName}/>
                    <RaikoCustomSelect
                        items={[
                            raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                            ...categoryInlineItems
                        ]}
                        labelText={"پدر"}
                        value={selectedParentId}
                        setValue={setSelectedParentId}
                    />
                    <RaikoFlexAlignEnd>
                        <RaikoButtonPrimary label={"بروزرسانی"} onClick={updateCategory}/>
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.CostAndRevenue.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.CostAndRevenueCategory.name,
                                RouteHelper.CostAndRevenueCategory.globalUrl,
                            )
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoAlert
                                title={"مشاهده و ویرایش دسته بندی"}
                                description={[
                                    "* برای افزودن دسته بندی جدید بعد از وارد کردن اطلاعات لازم بر روی دکمه ی افزودن کلیک نمایید.",
                                    "* برای ویرایش دسته بندی های کافی است دسته بندی مورد نظر را انتخاب کرده و بعد از اصلاح جزئیات بر روی بروزرسانی کلیک نمایید."
                                ]}
                                type={raikoAlertTypes.info}/>
                            <RaikoGridTwoColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام"}
                                    value={name}
                                    setValue={setName}/>
                                <RaikoCustomSelect
                                    labelText={"پدر"}
                                    value={parent}
                                    setValue={setParent}
                                    items={[
                                        raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                                        ...categoryInlineItems
                                    ]}
                                />
                            </RaikoGridTwoColumn>
                            <RaikoFlexAlignEnd>
                                <RaikoButtonPrimary label={"افزودن"} onClick={handleCreateNewCategory}/>
                            </RaikoFlexAlignEnd>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        {categoryPersianList && categoryPersianList.length > 0 ?
                            <RaikoTree
                                treeItems={categoryPersianList}
                                selectedItemsId={selectedItemsId}
                                handleItemClicked={handleSelectCategoryItem}
                            />

                            :
                            <RaikoErrorSection
                                title={"هیچ دسته بندی یافت نشد!"}
                                subTitle={"از بخش بالا می توانید دسته بندی مورد نظر خود را ایجاد نمایید."}
                                image={RaikoErrorSectionVectors.SORRY_ONE}
                            />}

                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}